<template>
  <div>
    <div class="form-row border-b-0">
      <template v-if="experiment && experiment.isTreatment">
        <SplitNameFormPartPd8753 v-on="$listeners" />
      </template>
      <template v-else-if="experiment">
        <NameField
          :label="$t('field.name.label')"
          placeholder=""
          v-on="$listeners"
        />
      </template>
    </div>

    <AddressFormGroup v-on="$listeners" />

    <div class="form-row border-t-0">
      <PhoneField
        :label="$t('field.phone.label')"
        placeholder=""
        v-on="$listeners"
      />
    </div>

    <div class="form-row">
      <EmailField
        :label="$t('field.email.label')"
        placeholder=""
        v-on="$listeners"
      />
    </div>

    <div class="form-row">
      <CommentsField
        :label="$t('field.comments.label')"
        :is-optional="true"
        placeholder=""
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import NameField from 'chimera/all/components/form/fields/name/NameField'
import EmailField from 'chimera/all/components/form/fields/email/EmailField'
import CommentsField from 'chimera/all/components/form/fields/comments/CommentsField'
import PhoneField from 'chimera/all/components/form/fields/phone/PhoneField'
import AddressFormGroup from 'chimera/all/themes/blueflow/components/form/part/address/AddressFormGroup'
import SplitNameFormPartPd8753 from 'chimera/all/components/form/parts/SplitNameFormPart.PD-8753.vue'
import { ExperimentSource } from 'chimera/all/mixins/usesExperiments'

export default {
  name: 'ContactInformationFormPart',

  components: {
    SplitNameFormPartPd8753,
    NameField,
    EmailField,
    CommentsField,
    PhoneField,
    AddressFormGroup,
  },

  /**
   * @returns {{experiment: undefined}}
   */
  data() {
    return {
      experiment: undefined,
    }
  },

  /**
   * @returns {Promise<void>}
   */
  async beforeMount() {
    // https://bambelo.absmartly.com/experiments/404
    this.experiment = await this.$store.dispatch('experiments/get', {
      id: 'PD-8785',
      source: ExperimentSource.ABSMARTLY,
    })
  },
}
</script>
